import { BaseDto } from "@models/base/baseDto.model";
import { PersonaSummaryDto } from "@models/persona/personaSummaryDto.mode";

export class ContactoDto extends BaseDto {
  public persona!: PersonaSummaryDto;
  public tipoContacto!: BaseDto;
  public valorContacto!: string;
  public preferido!: boolean;
  public empresaAsociada!: string;
  public fechaUltimoContacto!: Date | null;
  public tipoRelacion!: string;
  public fuenteContacto!: string;
  public notasSeguimiento!: string;
  public estadoContacto!: string;
  public categoriasEtiquetas!: string;
  public historialInteracciones!: string;
  public preferenciasContacto!: string;
  public observaciones!: string;
  public expanded?: boolean; // Para manejar la expansión del detalle

}
